module.exports = {
  "dof-music-player": {
    "paddingTop": "40",
    "paddingRight": "32",
    "paddingBottom": "40",
    "paddingLeft": "32",
    "boxShadow": "0px 1px 10px 0px rgba(0, 0, 0, 0.04)",
    "borderRadius": "32",
    "backgroundColor": "#ffffff",
    "position": "relative"
  },
  "title-hidden": {
    "position": "absolute",
    "left": 0,
    "top": "1000",
    "opacity": 0
  },
  "top-img": {
    "width": "40",
    "height": "40"
  },
  "play-top": {
    "display": "flex",
    "flexDirection": "row",
    "marginBottom": "66"
  },
  "top-title": {
    "flex": 1,
    "marginTop": 0,
    "marginRight": "24",
    "marginBottom": 0,
    "marginLeft": "24",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "top-title-text": {
    "fontSize": "32",
    "color": "#1E2E37",
    "lineHeight": "44",
    "whiteSpace": "normal",
    "wordWrap": "nomal"
  },
  "top-right": {
    "display": "flex",
    "flexDirection": "row"
  },
  "top-img-play": {
    "marginRight": "44"
  },
  "volume-content": {
    "paddingTop": 0,
    "paddingRight": "52",
    "paddingBottom": 0,
    "paddingLeft": "52",
    "position": "relative"
  },
  "volume-img": {
    "position": "absolute",
    "top": 0
  },
  "volume-img-left": {
    "left": 0
  },
  "volume-img-right": {
    "right": 0
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1451a23c!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-music-player/index.vue
// module id = 424
// module chunks = 0 1